// Newsletter lifetime is a dashboard rule, never a deletion of source records.
export const hasNewsletterReceiptIdentity = (event) => {
  if (event?.newsletter_receipt === true || event?._digest_receipt === true) return true;
  const segments = event?.source_segments || [];
  return segments.length > 0 && segments.every(segment =>
    String(segment?.segment_id || "").startsWith("digest_receipt=")
  );
};
export const isNewsletterCard = (event) => {
  if (event?.event_start || event?.event_date || (event?.actions || []).length) return false;
  const title = String(event?.event_name || event?.display_headline || "");
  return String(event?.provenance?.kind || "").toLowerCase() === "digest"
    || /\bnewsletter\b|^news digest(?:\b|$)/i.test(title);
};
export const newsletterReceivedAt = (event) =>
  event?.provenance?.received_at || event?.last_source_received_at
    || event?.source_received_at || event?.received_at || null;
export const visibleOrderedFyi = (events = [], now = new Date()) =>
  events.filter(event => {
    if (!isNewsletterCard(event)) return true;
    const received = Date.parse(newsletterReceivedAt(event) || "");
    return !Number.isFinite(received) || now.getTime() - received < 7 * 86400000;
  }).slice().sort((a, b) => {
    const aDate = a.event_start || a.event_date;
    const bDate = b.event_start || b.event_date;
    if (Boolean(aDate) !== Boolean(bDate)) return aDate ? -1 : 1;
    if (aDate && bDate) return String(aDate).localeCompare(String(bDate));
    return String(newsletterReceivedAt(b) || "").localeCompare(String(newsletterReceivedAt(a) || ""));
  });
